import { render, staticRenderFns } from "./EntryAttributes.vue?vue&type=template&id=fac4f116&scoped=true"
import script from "./EntryAttributes.vue?vue&type=script&lang=js"
export * from "./EntryAttributes.vue?vue&type=script&lang=js"
import style0 from "./EntryAttributes.vue?vue&type=style&index=0&id=fac4f116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac4f116",
  null
  
)

export default component.exports